export default __webpack_public_path__ + "static/media/ones.f793841a.png";